import { render, staticRenderFns } from "./component-f67cbdf8.vue?vue&type=template&id=38a37343&scoped=true&"
import script from "./component-f67cbdf8.vue?vue&type=script&lang=js&"
export * from "./component-f67cbdf8.vue?vue&type=script&lang=js&"
import style0 from "./component-f67cbdf8.vue?vue&type=style&index=0&id=38a37343&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a37343",
  null
  
)

export default component.exports